import React from 'react';

const IconCheckboxSelected = () => {
    return (
        <svg className="icon-svg" style={{ height: 30, width: 30 }} preserveAspectRatio="xMidYMid meet" viewBox="0 0 90 90">
            <g>
                <path d="M68,29c1.7,0,3,1.3,3,3v36c0,1.7-1.3,3-3,3H32c-1.7,0-3-1.3-3-3V32c0-1.7,1.3-3,3-3H68 M68,26H32c-3.3,0-6,2.7-6,6v36 c0,3.3,2.7,6,6,6h36c3.3,0,6-2.7,6-6V32C74,28.7,71.3,26,68,26L68,26z" />
                <path d="M36,51.7L48.7,63L66,39.4L60.8,36L47.7,53.9l-7.4-6.6L36,51.7L36,51.7z" />
            </g>
        </svg>
    )
};

export default IconCheckboxSelected;



// WEBPACK FOOTER //
// ./src/icons/icon-checkbox-selected.js